import { render, staticRenderFns } from "./MyOrgList.vue?vue&type=template&id=66613654&"
import script from "./MyOrgList.vue?vue&type=script&lang=js&"
export * from "./MyOrgList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports